import PropTypes from 'prop-types';
import { NamespaceProvider } from '@ux/namespace-component';
import UtilityBar from '@ux/utility-bar';
import ApplicationFooter from '@ux/application-footer';
import AbstractHeader from '@ux/abstract-header';
import { events } from '@ux/header-util';
import React from 'react';
import Presets from './presets.json';

/**
 * Return a namespace if the environment variable is set, 'polyfilled' by WebPack.
 *
 * @returns {Object} Configured namespace.
 * @api private
 */
function namespace() {
  return {
    namespace: process.env.NAMESPACE // eslint-disable-line no-process-env
  };
}

/**
 * Render and expose the Header as a functional Component.
 *
 * @param {Object} props Properties
 * @returns {ReactElement} Namespaced Header.
 * @api public
 */
class Header extends AbstractHeader {
  constructor(props) {
    super(...arguments);

    const preset = Presets[props.preset];
    this.state = {
      ...this.state,
      unauthenticated: preset
        && this.isUnauthenticated(preset.components)
    };
  }

  render() {
    const props = this.props;
    const cartProps = {
      items: this.state.cartItems,
      market: 'en-US',
      messages: props.messages,
      checkout: props.urls.checkout.href,
      eid: `uxp.hyd.${props.manifest}.header.cart.cart_link.link.click`,
      className: 'cart-link'
    };

    let preset = Presets[props.preset];
    if (!preset) {
      throw new Error('Header preset not defined. This service serves the following headers: ' + Object.keys(Presets).join(', '));
    }

    const plPreset = `${props.preset}-pl`;
    if (props.privateLabelId !== 1 && Presets[plPreset]) {
      preset = Presets[plPreset];
    }

    const components = preset.components || {};

    return (
      <NamespaceProvider { ...namespace() } >
        <div>
          { this.renderBanner(props) }
          <UtilityBar
            { ...props }
            { ...this.getCustomerState() }
            customer={ this.customer }
            components={ components }
            cart={ cartProps } />
        </div>
      </NamespaceProvider>
    );
  }
}

Header.propTypes = {
  preset: PropTypes.oneOf(Object.keys(Presets)).isRequired,
  supportContacts: PropTypes.object,
  messages: PropTypes.object.isRequired,
  urls: PropTypes.object.isRequired,
  traffic: PropTypes.string
};

/**
 * Render and expose the Footer as a functional Component.
 *
 * @param {Object} props Properties
 * @returns {ReactElement} Namespaced Header.
 * @api public
 */
class Footer extends React.Component {
  componentDidMount() {
    events.emit('mount', 'footer', this);
    events.emit('mount:footer', this);
  }

  render() {
    const props = this.props;
    const preset = Presets[this.props.preset];

    if (!preset.footer) {
      return null;
    }

    return (
      <NamespaceProvider { ...namespace() }>
        <ApplicationFooter { ...props } />
      </NamespaceProvider>
    );
  }
}

Footer.propTypes = {
  preset: PropTypes.oneOf(Object.keys(Presets)).isRequired
};

export {
  Header,
  Footer
};
